import React, { useState } from "react";
import { Card, Table, Button, Badge, Spinner } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { useGetChamps } from "../../hooks/CHAMPS/useGetChamps";
import { useDeleteChamp } from "../../hooks/CHAMPS/useChampsActions";
import { toast } from "react-toastify";
import EditChampModal from "../../components/Modals/Update/EditChamp";
import NewChampModal from "../../components/Modals/Create/NewChamp";
import { useAuth } from "../../context/AuthContext";

const ChampsAdministration = ({ titre }) => {
  const { data, isLoading, isError } = useGetChamps();
  const deleteChampMutation = useDeleteChamp();
  const { hasPermission } = useAuth();
  
  const [showNewModal, setShowNewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedChamp, setSelectedChamp] = useState(null);

  const champs = data?.data || [];

  const handleDelete = (champ) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer le champ "${champ.label}" ?`)) {
      deleteChampMutation.mutate(champ.id, {
        onSuccess: () => {
          toast.success("Champ supprimé avec succès");
        },
        onError: (error) => {
          toast.error(error.message || "Erreur lors de la suppression");
        },
      });
    }
  };

  const handleEdit = (champ) => {
    setSelectedChamp(champ);
    setShowEditModal(true);
  };

  return (
    <>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
        {hasPermission('CREATE_CHAMP') && (
        <Button variant="warning" onClick={() => setShowNewModal(true)}>
          <FaPlus className="me-2" />
          Nouveau champ
        </Button>
        )}
      </div>

      <div className="row">
        <div className="col-12">
          <Card className="border-left-warning shadow mb-4">
            <Card.Body>
              {isLoading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status" style={{ color: "#f6c23e" }}>
                    <span className="visually-hidden">Chargement...</span>
                  </Spinner>
                </div>
              ) : isError ? (
                <div className="alert alert-danger">
                  Erreur lors du chargement des champs personnalisés
                </div>
              ) : (
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Label</th>
                      <th>Nom de colonne</th>
                      <th>Type</th>
                      <th>Statut</th>
                      <th>Position</th>
                      <th>Largeur</th>
                      <th>Règle de visibilité</th>
                      <th>Requis</th>
                      <th>Éditable</th>
                      <th>Actif</th>
                      <th>Tous les clients</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {champs.length === 0 ? (
                      <tr>
                        <td colSpan={13} className="text-center">
                          Aucun champ personnalisé
                        </td>
                      </tr>
                    ) : (
                      champs.map((champ) => (
                        <tr key={champ.id}>
                          <td>{champ.id}</td>
                          <td>{champ.label}</td>
                          <td>
                            <code>{champ.column_name}</code>
                          </td>
                          <td>
                            {champ.field_type ? (
                              <Badge bg="info">{champ.field_type.label}</Badge>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {champ.field_apply_status ? (
                              <Badge bg="secondary">{champ.field_apply_status}</Badge>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>{champ.position}</td>
                          <td>{champ.width}</td>
                          <td>{champ.visibility_rule}</td>
                          <td className="text-center">
                            <Badge bg={champ.is_required ? "success" : "secondary"}>
                              {champ.is_required ? "Oui" : "Non"}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg={champ.is_editable ? "success" : "secondary"}>
                              {champ.is_editable ? "Oui" : "Non"}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg={champ.is_active ? "success" : "danger"}>
                              {champ.is_active ? "Actif" : "Inactif"}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg={champ.all_clients ? "primary" : "secondary"}>
                              {champ.all_clients ? "Oui" : "Non"}
                            </Badge>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              {hasPermission('EDIT_CHAMP') && (
                              <Button
                                variant="info"
                                size="sm"
                                onClick={() => handleEdit(champ)}
                              >
                                <FaEdit />
                              </Button>
                              )}
                              {hasPermission('DELETE_CHAMP') && (
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleDelete(champ)}
                                disabled={deleteChampMutation.isPending}
                              >
                                <FaTrash />
                              </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>

      <NewChampModal show={showNewModal} setShow={setShowNewModal} />
      <EditChampModal 
        show={showEditModal} 
        setShow={setShowEditModal} 
        champ={selectedChamp}
      />
    </>
  );
};

export default ChampsAdministration;
